import { render, staticRenderFns } from "./word-spec.vue?vue&type=template&id=0fea945a&scoped=true"
import script from "./word-spec.ts?vue&type=script&lang=ts&external"
export * from "./word-spec.ts?vue&type=script&lang=ts&external"
import style0 from "./word-spec.less?vue&type=style&index=0&id=0fea945a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea945a",
  null
  
)

export default component.exports